{
    "PageTitle_auth": "Authenticatie",
    "NAME": "Router",
    "PageTitle_presence": "Aanwezigheid",
    "PageTitle_changePassword": "Wachtwoord wijzigen",
    "PageTitle_forgotPassword": "Wachtwoord vergeten",
    "PageTitle_changeLanguage": "Taal wijzigen",
    "PageTitle_resetPassword": "Wachtwoord opnieuw instellen",
    "PageTitle_termsAndConditions": "Algemene voorwaarden",
    "PageTitle_cookiePolicy": "Cookiebeleid",
    "PageTitle_privacyPolicy": "Privacybeleid",
    "PageTitle_mfa": "Multi-factorauthenticatie",
    "PageTitle_teamsAuth": "Teams-authenticatie",
    "PageTitle_insights": "Inzichten",
    "PageTitle_crmIntegration": "CRM-integratie",
    "PageTitle_changeUserAgent": "Gebruikersagent wijzigen",
    "PageTitle_clientConfiguration": "Clientconfiguratie",
    "PageTitle_CRMConfiguration": "CRM-configuratie",
    "PageTitle_adminControl": "Beheerfuncties"
}